module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_vm._m(0), _vm._v(" "), (_vm.filteredSocialReasonsWithoutTrm.length) ? _c('div', {
    staticClass: "mx-2 mt-4"
  }, [_c('div', {
    staticClass: "flex flex-col bg-red-200 rounded-lg p-4 mb-2 text-sm text-red-700",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "flex mb-2"
  }, [_c('svg', {
    staticClass: "w-5 h-5 inline mr-3",
    attrs: {
      "fill": "currentColor",
      "viewBox": "0 0 20 20",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
      "clip-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "font-medium"
  }, [_vm._v("Algunas razones sociales no tienen Trm para este mes:\n                ")])]), _vm._v(" "), _vm._l((_vm.filteredSocialReasonsWithoutTrm), function(socialreason) {
    return _c('ul', {
      key: ("" + (socialreason.id)),
      staticClass: "list-disc list-inside"
    }, [_c('li', {
      staticClass: "font-medium"
    }, [_vm._v("\n                  " + _vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix) + "\n                ")])])
  }), _vm._v(" "), _c('a', {
    staticClass: "underline font-bold mt-2 hover:text-red-600",
    attrs: {
      "href": '/admin/business/social-reasons'
    }
  }, [_vm._v("Ir a Razones Sociales")])], 2)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkBudget.apply(null, arguments)
      }
    }
  }, [(_vm.budget.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Moneda cambio")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1 bg-gray-200"
  }, [_vm._v("\n                " + _vm._s(_vm.budget.money_code) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.budget.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("1 dólar es igual a:")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2 flex-1 bg-gray-200"
  }, [_vm._v("\n                " + _vm._s(_vm.budget.usd_convertion) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Razon Social")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.social_reason_id),
      expression: "budget.social_reason_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.checked
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "social_reason_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.resetBudgetItems('social_reason_id')
        _vm.selectSocialReason()
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                  Seleccione la Razon Social\n                ")]), _vm._v(" "), _vm._l((_vm.socialreasons), function(socialreason) {
    return _c('option', {
      key: ((socialreason.id) + "-social-reason"),
      domProps: {
        "value": socialreason.id
      }
    }, [_vm._v("\n                  " + _vm._s(socialreason.name) + " - " + _vm._s(socialreason.country_prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Referencia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.reference),
      expression: "budget.reference"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.budget.reference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.budget, "reference", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.budget.social_reason_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Cliente")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.client_id),
      expression: "budget.client_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.checked
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "client_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.accountsClient()
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione Cliente...")]), _vm._v(" "), _vm._l((_vm.filteredClients), function(client) {
    return _c('option', {
      key: ((client.id) + "-client"),
      domProps: {
        "value": client.id
      }
    }, [_vm._v("\n                  " + _vm._s(client.social_reason) + " (" + _vm._s(client.accounts.length) + "\n                  Cuentas)\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.client_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Cuenta")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.account_id),
      expression: "budget.account_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": !_vm.budget.social_reason_id || _vm.checked
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetBudgetItems('account_id')
      }]
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione una cuenta")]), _vm._v(" "), _vm._l((_vm.accounts_client), function(account) {
    return _c('option', {
      key: ((account.id) + "-account"),
      domProps: {
        "value": account.id
      }
    }, [_vm._v("\n                  " + _vm._s(account.name) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.account_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Director")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.ejecutive_id),
      expression: "budget.ejecutive_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "ejecutive_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione Director...")]), _vm._v(" "), _vm._l((_vm.filteredEjecutives), function(ejecutive) {
    return _c('option', {
      key: ((ejecutive.id) + "-ejecutive"),
      domProps: {
        "value": ejecutive.id
      }
    }, [_vm._v("\n                  " + _vm._s(ejecutive.name) + " - " + _vm._s(ejecutive.email) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.ejecutive_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.project_id),
      expression: "budget.project_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": !_vm.budget.account_id || _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "project_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione un proyecto")]), _vm._v(" "), _vm._l((_vm.filteredProjects), function(project) {
    return _c('option', {
      key: ((project.id) + "-project"),
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.project_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.campaign_id),
      expression: "budget.campaign_id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": !_vm.budget.project_id || _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "campaign_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione la campaña")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      key: ((campaign.id) + "-campaign"),
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.budget.campaign_id) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Tipo de presupuesto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.type),
      expression: "budget.type"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": "",
      "disabled": _vm.checked
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budget, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": "",
      "value": "null"
    }
  }, [_vm._v("Seleccione tipo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cliente"
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cargo agencia"
    }
  }, [_vm._v("Cargo Agencia")])])]) : _vm._e(), _vm._v(" "), (_vm.budget.type) ? _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Comision Agencia")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budget.commission_agency),
      expression: "budget.commission_agency"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "step": ".01",
      "required": "",
      "disabled": _vm.checked
    },
    domProps: {
      "value": (_vm.budget.commission_agency)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.budget, "commission_agency", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.budget.type) ? _c('div', {
    staticClass: "col-span-12"
  }, [_c('div', {
    staticClass: "px-5 sm:px-8 py-5 sm:py-10"
  }, [_c('div', {
    staticClass: "overflow-x-auto"
  }, [_c('table', {
    staticClass: "table table-custom"
  }, [_vm._m(1), _vm._v(" "), (!_vm.budgetitems.length) ? _c('tbody', [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.budgetitems), function(item, index) {
    return _c('tbody', {
      key: ((item.name) + "-budget-item-" + index),
      staticClass: "border-b dark:border-dark-5"
    }, [_c('tr', [_c('td', [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.lazy",
        value: (item.name),
        expression: "item.name",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "change": function($event) {
          return _vm.$set(item, "name", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.quantity),
        expression: "item.quantity"
      }],
      staticClass: "input w-20 border mt-auto flex-1",
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (item.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "quantity", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                            " + _vm._s(item.quantity) + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('currency-input', {
      staticClass: "input w-full border mt-2 text-center",
      attrs: {
        "id": item.id,
        "locale": "es",
        "precision": 5,
        "valueRange": {
          min: 0
        },
        "distraction-free": {
          hideNegligibleDecimalDigits: true,
        },
        "currency": {
          prefix: '$ '
        }
      },
      on: {
        "blur": function($event) {
          item.unit_value == null ?
            (item.unit_value = 0) :
            ''
        }
      },
      model: {
        value: (item.unit_value),
        callback: function($$v) {
          _vm.$set(item, "unit_value", $$v)
        },
        expression: "item.unit_value"
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                            $" + _vm._s(_vm.formatPrice(item.unit_value)) + "\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-center"
    }, [_vm._v("SUBTOTAL:")]), _vm._v(" "), _c('div', {
      staticClass: "text-center"
    }, [_vm._v("\n                              $\n                              " + _vm._s(_vm.formatPrice(item.quantity * item.unit_value)) + "\n                            ")])])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.iva),
        expression: "item.iva"
      }],
      staticClass: "input w-full border mt-auto flex-1",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "iva", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("0%")]), _vm._v(" "), (_vm.selectedSocialReason.iva) ? _c('option', {
      domProps: {
        "value": _vm.selectedSocialReason.iva
      }
    }, [_vm._v("\n                              " + _vm._s(_vm.selectedSocialReason.iva) + "%\n                            ")]) : _vm._e()]) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                            " + _vm._s(item.iva) + "%\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                              VALOR:\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                              $\n                              " + _vm._s(_vm.formatPrice(
      _vm.percentCalculator(
        item.iva,
        item.quantity * item.unit_value
      )
    )) + "\n                            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [(!_vm.checked) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.commission),
        expression: "item.commission"
      }],
      staticClass: "input w-full border mt-auto flex-1 text-center",
      attrs: {
        "name": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "commission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": 0
      }
    }, [_vm._v("0%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 1
      }
    }, [_vm._v("1%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 2.5
      }
    }, [_vm._v("2,5%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("3%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3.2
      }
    }, [_vm._v("3,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4
      }
    }, [_vm._v("4%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4.2
      }
    }, [_vm._v("4,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 6
      }
    }, [_vm._v("6%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 7.2
      }
    }, [_vm._v("7,2%")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 8
      }
    }, [_vm._v("8%")])]) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                            " + _vm._s(item.commission) + "%\n                          ")]), _vm._v(" "), _c('div', {
      staticClass: "mt-3"
    }, [_c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                              VALOR:\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "text-center whitespace-no-wrap"
    }, [_vm._v("\n                              $\n                              " + _vm._s(_vm.formatPrice(
      _vm.percentCalculator(
        item.commission,
        item.quantity * item.unit_value
      )
    )) + "\n                            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('div', {
      staticClass: "whitespace-no-wrap text-center"
    }, [_vm._v("\n                            $\n                            " + _vm._s(_vm.formatPrice(
      item.quantity * item.unit_value +
      _vm.percentCalculator(
        item.iva,
        item.quantity * item.unit_value,
        false
      ) +
      _vm.percentCalculator(
        item.commission,
        item.quantity * item.unit_value,
        false
      )
    )) + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "flex flex-col"
    }, [(!_vm.checked) ? _c('currency-input', {
      staticClass: "input w-full border mt-2 text-center",
      attrs: {
        "id": item.id,
        "locale": "es",
        "precision": 5,
        "valueRange": {
          min: 0
        },
        "distraction-free": {
          hideNegligibleDecimalDigits: true,
        },
        "currency": {
          prefix: '$ '
        }
      },
      model: {
        value: (item.unit_value_internal),
        callback: function($$v) {
          _vm.$set(item, "unit_value_internal", $$v)
        },
        expression: "item.unit_value_internal"
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap text-center"
    }, [_vm._v("\n                              $" + _vm._s(_vm.formatPrice(item.unit_value_internal)) + "\n                            ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.supplier_id),
        expression: "item.supplier_id"
      }],
      staticClass: "input w-full border mt-auto flex-1 text-center",
      attrs: {
        "disabled": _vm.checked
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "supplier_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Seleccionar ...")]), _vm._v(" "), _vm._l((_vm.suppliers), function(supplier, index) {
      return _c('option', {
        key: ((supplier.id) + "-" + index + "-supplier"),
        domProps: {
          "value": supplier.id
        }
      }, [_vm._v("\n                                " + _vm._s(supplier.social_reason) + "\n                              ")])
    })], 2)], 1)]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      attrs: {
        "rowspan": "2"
      }
    }, [(!_vm.checked) ? _c('button', {
      staticClass: "button bg-theme-6 text-white mt-auto",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.budgetitems.splice(index, 1)
        }
      }
    }, [_vm._v("\n                            Eliminar\n                          ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v("DESCRIPCION(*):")]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "4"
      }
    }, [(!_vm.checked) ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "3",
        "required": ""
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    }) : _c('div', {
      staticClass: "font-medium whitespace-nowrap"
    }, [_vm._v("\n                            " + _vm._s(item.description) + "\n                          ")])])])])
  })], 2)]), _vm._v(" "), (!_vm.checked) ? _c('div', {
    staticClass: "intro-y grid grid-cols-12 gap-3 py-5 bg-gray-400 px-2 rounded"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-6"
  }, [_c('label', [_vm._v("Agregar item:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCurrentItem.id),
      expression: "budgetCurrentItem.id"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.budgetCurrentItem, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "seleted": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.filteredBudgetElements), function(element) {
    return _c('option', {
      key: ((element.id) + "-budget-element"),
      domProps: {
        "value": element.id
      }
    }, [_vm._v("\n                        " + _vm._s(element.name) + " - $\n                        " + _vm._s(_vm.formatPrice(element.value)) + "\n                      ")])
  }), _vm._v(" "), (_vm.filteredBudgetElements.length) ? _c('option', {
    attrs: {
      "value": "special"
    }
  }, [_vm._v("\n                        Nuevo Elemento\n                      ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-3"
  }, [_c('label', [_vm._v("Cantidad:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCurrentItem.quantity),
      expression: "budgetCurrentItem.quantity"
    }],
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.budgetCurrentItem.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.budgetCurrentItem, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12 md:col-span-3 flex"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button",
      "disabled": !_vm.budgetCurrentItem.id
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_vm._v("\n                      Agregar\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "px-5 sm:px-20 pb-10 sm:pb-20 flex flex-col-reverse sm:flex-row"
  }, [_c('div', {
    staticClass: "text-center sm:text-right sm:ml-auto mt-5"
  }, [_c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.budget.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.subtotal)) + "\n                      ")])]), _vm._v(" "), (_vm.subtotal) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        USD $ " + _vm._s(_vm.formatPrice(_vm.budget.usd_subtotal)) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Impuestos subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.budget.money_code) + " $\n                        " + _vm._s(_vm.formatPrice(_vm.taxSubtotal)) + "\n                      ")])]), _vm._v(" "), (_vm.budget.usd_convertion) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Impuestos subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        USD $\n                        " + _vm._s(_vm.formatPrice(_vm.taxSubtotal / _vm.budget.usd_convertion)) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Comision subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        " + _vm._s(_vm.budget.money_code) + " $\n                        " + _vm._s(_vm.formatPrice(_vm.commissionSubtotal)) + "\n                      ")])]), _vm._v(" "), (_vm.budget.usd_convertion) ? _c('div', {
    staticClass: "text-base text-gray-600"
  }, [_vm._v("\n                      Comision subtotal:\n                      "), _c('span', {
    staticClass: "text-lg text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_vm._v("\n                        USD $\n                        " + _vm._s(_vm.formatPrice(
    _vm.commissionSubtotal / _vm.budget.usd_convertion
  )) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("TOTAL:")]), _vm._v("\n                      " + _vm._s(_vm.budget.money_code) + " $ " + _vm._s(_vm.formatPrice(_vm.total)) + "\n                    ")]), _vm._v(" "), (_vm.total) ? _c('div', {
    staticClass: "text-xl text-theme-1 dark:text-theme-10 font-medium mt-2"
  }, [_c('span', {
    staticClass: "text-gray-600"
  }, [_vm._v("TOTAL: ")]), _vm._v("\n                      USD $ " + _vm._s(_vm.formatPrice(_vm.budget.usd_total)) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-1 tetx-xs"
  }, [_vm._v("Incluye Impuestos")])])])])]) : _vm._e(), _vm._v(" "), (_vm.checked) ? _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createBudget()
      }
    }
  }, [_vm._v("\n                Confirmar Presupuesto\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-11 text-white mt-auto",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.checked = false
      }
    }
  }, [_vm._v("\n                Editar Presupuesto\n              ")])]) : _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white mt-auto",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Crear Presupuesto\n              ")])])])])])])]) : _c('app-loading'), _vm._v(" "), (_vm.boxtrmchange) ? _c('TrmChangeModal', {
    attrs: {
      "socialreason": _vm.selectedSocialReason,
      "message": "No se ha actualizado este mes el TRM"
    },
    on: {
      "closeModal": function($event) {
        _vm.boxtrmchange = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Crear Presupuesto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "border-b dark:border-dark-5"
  }, [_c('th', {
    staticClass: "whitespace-nowrap text-center p-1"
  }, [_vm._v("\n                          CONCEPTO ITEM\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("QTY")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                          VALOR UNITARIO\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("IVA")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                          COMISION\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                          V INTERNO/PROVEEDOR\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "whitespace-nowrap text-center"
  }, [_vm._v("\n                          ACCIONES\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("\n                          No hay Elementos seleccionados\n                        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ac82f3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/budgets/CreateBudget.vue
// module id = 465
// module chunks = 1